import { useEffect } from 'react';
import { useFetch } from '@sravni/react-utils';

// TODO: Удалить когда все проекты переедут на версию пакета 0.4.6
const LOCALSTORAGE_V1_NAME = 'sravni-regional-centers';
const LOCALSTORAGE_V2_NAME = 'sravni-regional-centers-v2';
const LOCALSTORAGE_TTL = 3 * 30 * 24 * 60 * 60 * 1000; // 3 месяца
// TODO: Удалить когда все проекты переедут на версию пакета 0.4.6
const getRegionalCentersV1Cache = () => {
    const valueFromLocalstorage = window?.localStorage?.getItem(LOCALSTORAGE_V1_NAME);
    if (!valueFromLocalstorage)
        return undefined;
    try {
        return JSON.parse(valueFromLocalstorage);
    }
    catch (error) {
        console.log(error);
        return undefined;
    }
};
const getIsRegionalCentersCacheExpired = (regionalCentersCache) => {
    const { expires } = regionalCentersCache;
    if (!expires)
        return true;
    return expires <= Date.now();
};
const getRegionalCentersCache = () => {
    const valueFromLocalstorage = window?.localStorage?.getItem(LOCALSTORAGE_V2_NAME);
    if (!valueFromLocalstorage)
        return undefined;
    try {
        return JSON.parse(valueFromLocalstorage);
    }
    catch (error) {
        console.log(error);
        return undefined;
    }
};
const useRegionalCenters = () => {
    const [{ get, data: regionalCentersFromFetch, loading, error }] = useFetch(new URL('/location/v2/locations/regional-centers/', "https://api.sravni.ru").toString());
    // TODO: Удалить когда все проекты переедут на версию пакета 0.4.6
    const oldCenters = getRegionalCentersV1Cache();
    const regionalCentersCache = getRegionalCentersCache();
    useEffect(() => {
        if (regionalCentersCache && !getIsRegionalCentersCacheExpired(regionalCentersCache)) {
            return;
        }
        get();
    }, [get, regionalCentersCache]);
    // TODO: Удалить когда все проекты переедут на версию пакета 0.4.6
    useEffect(() => {
        if (oldCenters && !getIsRegionalCentersCacheExpired(oldCenters)) {
            return;
        }
        window?.localStorage?.removeItem(LOCALSTORAGE_V1_NAME);
    }, [oldCenters]);
    useEffect(() => {
        if (regionalCentersFromFetch) {
            const cache = {
                expires: Date.now() + LOCALSTORAGE_TTL,
                data: regionalCentersFromFetch,
            };
            window?.localStorage?.setItem(LOCALSTORAGE_V2_NAME, JSON.stringify(cache));
        }
    }, [regionalCentersFromFetch]);
    return {
        data: regionalCentersCache?.data ? regionalCentersCache.data : regionalCentersFromFetch,
        loading,
        error,
    };
};

export { useRegionalCenters };
//# sourceMappingURL=useRegionalCenters.js.map
